var path = 'app/scripts/modules/core/src/forms/checkmap/checkmap.directive.html';
var html = "<ul class=\"checkmap\">\n  <li ng-repeat=\"(key, valList) in itemMap\" class=\"checkmap-group\">\n    <ul class=\"checkmap\">\n      <li class=\"checkmap-header\">{{key}}</li>\n      <li ng-repeat=\"item in valList\">\n        <label>\n          <input type=\"checkbox\" ng-checked=\"!!modelHolder[key][item]\" ng-model=\"modelHolder[key][item]\" ng-change=\"updateSelectedItems()\">\n          {{item}}\n        </label>\n      </li>\n    </ul>\n  </li>\n</ul>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/forms/checkmap/checkmap.directive.html
// module id = 1095
// module chunks = 0